// IBA "Weekly Payout" (/income): hidden until customer confirms the figures.
export const WEEKLY_PAYOUT_PAGES_ENABLED = false;
// IBA "Weekly Payout History" (/weekly-payouts): turned back on by the customer 2026-10-11.
export const WEEKLY_PAYOUT_HISTORY_ENABLED = true;
export const HIDDEN_PAYOUT_PATHS = [
  ...(WEEKLY_PAYOUT_PAGES_ENABLED ? [] : ["/income"]),
  ...(WEEKLY_PAYOUT_HISTORY_ENABLED ? [] : ["/weekly-payouts"]),
];
